module.exports = __webpack_public_path__ + "img/growth.32e1ccb4.svg";